import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 4_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

// Common cache keys
export const qk = {
  bridge: {
    config: ["bridge", "config"] as const,
    status: ["bridge", "status"] as const,
    agents: ["bridge", "agents"] as const,
    personas: ["bridge", "personas"] as const,
    workspaces: ["bridge", "workspaces"] as const,
    channels: ["bridge", "channels"] as const,
    journals: ["bridge", "journals"] as const,
    journal: (id: string) => ["bridge", "journal", id] as const,
    logs: (opts: Record<string, unknown>) => ["bridge", "logs", opts] as const,
    personaPrompt: (name: string) => ["bridge", "persona-prompt", name] as const,
  },
  bus: {
    messages: (opts: Record<string, unknown>) => ["bus", "messages", opts] as const,
    message: (id: string) => ["bus", "message", id] as const,
    agents: ["bus", "agents"] as const,
    stats: ["bus", "stats"] as const,
    health: ["bus", "health"] as const,
    scheduledTasks: (opts: Record<string, unknown>) => ["bus", "scheduled-tasks", opts] as const,
    scheduledTaskStats: ["bus", "scheduled-task-stats"] as const,
    taskRuns: (opts: Record<string, unknown>) => ["bus", "task-runs", opts] as const,
  },
  requests: {
    list: (opts: Record<string, unknown>) => ["requests", "list", opts] as const,
    conversation: (chatJid: string) => ["requests", "conversation", chatJid] as const,
  },
  spawns: {
    list: (opts: Record<string, unknown>) => ["spawns", "list", opts] as const,
    detail: (id: string) => ["spawns", "detail", id] as const,
  },
  delegations: {
    list: (opts: Record<string, unknown>) => ["delegations", "list", opts] as const,
    detail: (id: string) => ["delegations", "detail", id] as const,
  },
  jobs: {
    list: (opts: Record<string, unknown>) => ["jobs", "list", opts] as const,
    detail: (id: string) => ["jobs", "detail", id] as const,
  },
  skills: {
    list: ["skills", "list"] as const,
    fleetAgents: ["skills", "fleet-agents"] as const,
    assignments: ["skills", "assignments"] as const,
    catalog: ["skills", "catalog"] as const,
    detail: (name: string) => ["skills", "catalog", name] as const,
  },
  builder: {
    list: ["builder", "list"] as const,
    detail: (id: string) => ["builder", "detail", id] as const,
  },
  personaBuilder: {
    list: ["persona-builder", "list"] as const,
    detail: (id: string) => ["persona-builder", "detail", id] as const,
  },
  mcpBuilder: {
    list: ["mcp-builder", "list"] as const,
    detail: (id: string) => ["mcp-builder", "detail", id] as const,
  },
  revisions: {
    list: (opts: Record<string, unknown>) => ["revisions", "list", opts] as const,
  },
  dashboard: {
    missionControl: ["dashboard", "mission-control"] as const,
  },
  analytics: {
    overview: (window: string) => ["analytics", "overview", window] as const,
  },
  mcp: {
    overview: ["mcp", "overview"] as const,
  },
};
